export const WEBSITE_ROUTES = {
  PROFILE: '/profile/personal_info',
  PARTNER_PROFILE: '/partner-profile',
  PRODUCT: '/product',
};
